import { render, staticRenderFns } from "./CardPos.vue?vue&type=template&id=78e2808e&"
import script from "./CardPos.vue?vue&type=script&lang=js&"
export * from "./CardPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports